import { Component, OnInit, OnDestroy } from '@angular/core';
import { ResourceService } from 'sce-core';
import { ViewLottableService } from './viewlottables-lookup.service';
import { AlertService } from 'sce-core';
import { ModalService } from '../../services/modal.service';
import { DatePickerConfigService } from '../../components/datepicker/datepicker-config.service';
import { InventoryAdjustmentDataService } from '../../../features/inventory/inventory-adjustment/service/inventory-adjustment-data.service';

@Component({
  selector: 'lfwms-viewlottables-lookup ',
  templateUrl: './viewlottables-lookup.component.html',
  styleUrls: ['./viewlottables-lookup.component.css']
})
export class ViewLottablesLookupComponent implements OnInit, OnDestroy {

  public title: any;
  public adjustmentKey: any;
  public finalizedFlag: any;
  public selectedLineItemFinalizedFlag: any;
  private adjustmentSelectedRow: any;
  public adjustmentLineNumber: string;
  public commodity: string = '';
  private lottables: any[];
  public showLookup: boolean = false;
  public filteredLottables: any = [];
  public filteredLottablesMap: any = [];
  public updatedLottables: any = [];
  public dateFormat: string;
  public dateTimeFormat: string;
  /* Below gridAPIRef needs to be set using
   modalRef.content.gridAPIRef = this.dataService.getDetailsSearchService().getPagedData().aggridApi;
  before calling the lookup to be rendered.
  gridAPIRef.refreshCells() can be called after save inside popup*/
  public gridAPIRef;
  // used to show hide edit button.. needs to be set before lookup is called
  public isParentInEditMode: boolean;
  public tableId: string;

  private dataService :InventoryAdjustmentDataService;
  public lottabelLabelArray = [
    'Lottable01',
    'Lottable02',
    'Lottable03',
    'Lottable04',
    'Lottable05',
    'Lottable06',
    'Lottable07',
    'Lottable08',
    'Lottable09',
    'Lottable10',
    'Lottable11',
    'Lottable12',
    'Lottable13',
    'Lottable14',
    'Lottable15'];

  constructor(protected alertService: AlertService,
    public resourceService: ResourceService,
    public modalService: ModalService,
    public viewLottableService: ViewLottableService,
    private dateConfigService: DatePickerConfigService) { }

  ngOnInit() {
    this.dateFormat = this.dateConfigService.defaultDateDisplayFormat;
    this.dateTimeFormat = this.dateConfigService.defaultDateDisplayFormat + ' ' + this.dateConfigService.defaultTimeDisplayFormat;
  }
   /* jira -1886 this function for making edit mode
    inactive after closing the viewlottables lookup*/
  public ngOnDestroy() {
    this.viewLottableService.displayMode = 'V';
  }
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public initializeComponent(adjustmentSelectedRow: any, dynamicLabels: any, dataService:any) {
      this.dataService = dataService;
      this.lottables = dynamicLabels;
      this.lottables.forEach(lottable => {
        // LFWM-1941 fixes - if lottable.label is '' or NULL then we need to display lottable.property as label
        if (lottable.label.trim() === '') {
          lottable.label = lottable.property;
        }
        lottable.value = adjustmentSelectedRow.cells[lottable.property.toLowerCase()].cVal;

        this.filteredLottables.push(lottable);
        this.filteredLottablesMap[lottable.property] = [];
        this.filteredLottablesMap[lottable.property].push(lottable);
        this.filteredLottablesMap[lottable.property].isEdited = false;
      });

    this.adjustmentLineNumber = adjustmentSelectedRow.cells['adjustmentLineNumber'].cVal;
    this.commodity = adjustmentSelectedRow.cells['sku'].cVal;

    this.adjustmentSelectedRow = adjustmentSelectedRow;
    this.viewLottableService.finalizedFlag = this.finalizedFlag;
    this.viewLottableService.selectedLineItemFinalizedFlag = this.selectedLineItemFinalizedFlag;
    this.viewLottableService.tableId = this.tableId;
    this.viewLottableService.initializeButtonPanel();
  }


  public valueChanged(property: any, event: any) {
    this.filteredLottablesMap[property].isEdited = true;
    //LFWM-3559 Recalculate lottable values
    if (property === 'Lottable04' ||
      property === 'Lottable05' ||
      property === 'Lottable13' ||
      property === 'Lottable14' ||
      property === 'Lottable15'
    ) {
      this.lottableRecalculate(this.dataService.detailsSearchService.getMetadata().columnList.find(element => element.propertyName === property.toLowerCase()));
    }
  }

  public handleButtonPanelActions(action) {
    switch (action) {
      case 'Edit': {
        this.viewLottableService.displayMode = 'E';
        this.viewLottableService.initializeButtonPanel();
        break;
      }
      case 'Save': {
        Object.keys(this.filteredLottablesMap).forEach((key) => {
          if (this.filteredLottablesMap[key].isEdited) {
             const lowerCaseKey = key.toLowerCase();

             this.adjustmentSelectedRow.cells[lowerCaseKey].cValPrev =  this.adjustmentSelectedRow.cells[lowerCaseKey].cVal;
             this.adjustmentSelectedRow.cells[lowerCaseKey].cVal = this.filteredLottablesMap[key][0].value;
             this.adjustmentSelectedRow.cells[lowerCaseKey].isEdited = true;
             this.adjustmentSelectedRow.isEdited = true;
          }
        });
        this.viewLottableService.displayMode = 'V';
        this.viewLottableService.initializeButtonPanel();
        // to refresh cells inside table after values are updated within the popup
        this.gridAPIRef.refreshCells();
        break;
      }
    }
  }

  //LFWM-3559 function to recalculate lottable values
  public lottableRecalculate(columnMeta: any): boolean {
    let request: any = {};
    const recieptlottableList = {};
    let isproceed: boolean = false; // true - when changing lottable field
    isproceed = this.lottabelLabelArray
      .some(element => element.toLowerCase() === columnMeta.propertyName);
    if (isproceed) {
      for (const lottable of this.lottabelLabelArray) {
        recieptlottableList[lottable.toLowerCase()] = this.filteredLottablesMap[lottable][0].value;
      }
      request = {
        'listName': columnMeta.propertyName,
        'storerKey': this.dataService.primaryDataMap['storerKey'].cVal,
        'sku': this.adjustmentSelectedRow.cells['sku'].cVal,
        'sourceKey': this.dataService.primaryDataMap['adjustmentKey'].cVal
          + this.adjustmentSelectedRow.cells['adjustmentLineNumber'].cVal,
        'sourceType': 'ADJ',
        'receiptLottableList': recieptlottableList,
        'prePost': '',
        'tableId': this.dataService.primarySearchParams.tableId
      };
      this.viewLottableService.lottableReCalculate(request)
        .subscribe((res: any) => {
          if (res.statusCode === 200 && res.statusMessage === 'SUCCESS') {
            for (const lottable of this.lottabelLabelArray) {
              if (res[lottable.toLowerCase()]) {
                this.filteredLottables.forEach((item) => {
                  if (item.property === lottable) {
                    item.value = res[lottable];
                  }
                });
                this.filteredLottablesMap[lottable][0].value = res[lottable.toLowerCase()];
                this.filteredLottablesMap[lottable].isEdited = true;
              }
            }
          }
          if (res.errMsg) {
            this.alertService.clearAll().error(res['errMsg']);
          }
        });
    }
    return true;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/viewlottables-lookup/viewlottables-lookup.component.ts